

import { InputSwitch as PrimereactInputSwitch} from 'primereact/inputswitch';
import { classNames } from 'primereact/utils';
        

const InputSwitch = ({showLabel = true, label, labelOnRight = true, className,...rest}) => {
    const id = `is-${rest.id}`;
    return (
        <div className={classNames('flex align-items-center', className)} id={rest.id}>
            <PrimereactInputSwitch id={id} {...rest} />
            {showLabel && labelOnRight && <label htmlFor={id} className="ml-2 checkbox-label">{label}</label>}
        </div>
    )
}

export default InputSwitch;